<template>
<div>
	<header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">เกี่ยวกับ Webhook</h1>
    </header>
    <div class="MarkdownContent" style="width: 70vw;">
      <p class="preindent"> Webhooks เป็น HTTP POST ที่ใช้ในการรับการแจ้งเตือนความเคลื่อนไหวทั้งหมดที่เกียวข้องกับบอท ทั้งข้อความที่ส่งเข้ามา, การเพิ่มเพื่อน, การดึงบอทเข้ากลุ่ม ข้อมูลทั้งหมดจะถูกส่งจาก Server ONE CHAT มายัง url ของคุณ ที่คุณได้ตั้งค่าไว้ในหน้าข้อมูลของบอท</p>


      <p class="preindent"> หมายเหตุ: เพื่อความปลอดภัย URL ที่ใช้ควรเป็น HTTPS และมีใบรับรองความปลอดภัยทางอิเล็กทรอนิกส์บนมาตรฐาน SSL (Security Socket Layer) ที่ผ่านการรับรองจาก CA</p>

      <p class="preindent">หลังจากกรอกข้อมูล WebHook แล้ว ผู้ใช้งานบอทจะสามารถรับการแจ้งเตือนต่างๆที่เกี่ยวกับบอทได้แบบ realtime ตามอีเว้นท์ต่างๆดังนี้</p>






    </div>
    รูปแบบการรับข้อมูล
<ul v-if="path == '/develop/docs/webhook/aboutwebhook'">
     <li><a  @click="toPage('/develop/docs/webhook/receive_message')">การรับแบบข้อความ</a></li>
     <li><a  @click="toPage('/develop/docs/webhook/receive_file')">การรับแบบไฟล์ต่างๆ</a></li>
     <li><a  @click="toPage('/develop/docs/webhook/receive_location')">การรับแบบโลเคชั่น</a></li>
     <li><a  @click="toPage('/develop/docs/webhook/receive_sticker')">การรับแบบสติกเกอร์</a></li>
</ul>
<ul v-else>
     <li><a  @click="toPage('/docs/webhook/receive_message')">การรับแบบข้อความ</a></li>
     <li><a  @click="toPage('/docs/webhook/receive_file')">การรับแบบไฟล์ต่างๆ</a></li>
     <li><a  @click="toPage('/docs/webhook/receive_location')">การรับแบบโลเคชั่น</a></li>
     <li><a  @click="toPage('/docs/webhook/receive_sticker')">การรับแบบสติกเกอร์</a></li>
</ul>
<br>
แจ้งเตือนเหตุการณ์ต่างๆ
<ul v-if="path == '/develop/docs/webhook/aboutwebhook'">
     <li><a @click="toPage('/develop/docs/webhook/noti_addbot')">มีการเพิ่มบอทเป็นเพื่อน</a></li>
     <li><a @click="toPage('/develop/docs/webhook/noti_addgroup')">มีการเพิ่มบอทเข้ากลุ่ม</a></li>
     <li><a @click="toPage('/develop/docs/webhook/noti_leavegroup')">มีการลบบอทออกจากกลุ่ม</a></li>
</ul>
<ul v-else>
     <li><a @click="toPage('/docs/webhook/noti_addbot')">มีการเพิ่มบอทเป็นเพื่อน</a></li>
     <li><a @click="toPage('/docs/webhook/noti_addgroup')">มีการเพิ่มบอทเข้ากลุ่ม</a></li>
     <li><a @click="toPage('/docs/webhook/noti_leavegroup')">มีการลบบอทออกจากกลุ่ม</a></li>
</ul>

</div>

</template>
<script>
export default {
  data: () => ({
    path: ''
  }),
  methods: {
    toPage (page) {
      this.$router.push(page)
    }
  },
  created () {
    this.path = this.$router.currentRoute.path
  }
}
</script>

<style type="text/css">
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/webhook/aboutwebhook.vue